import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPortalOutlinedUserIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.33333 20C5.33333 20 4 20 4 18.6667C4 17.3333 5.33333 13.3333 12 13.3333C18.6667 13.3333 20 17.3333 20 18.6667C20 20 18.6667 20 18.6667 20H5.33333Z", fill: "#4B7987" }), /* @__PURE__ */ React.createElement("path", { d: "M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z", fill: "#4B7987" }));
const ForwardRef = forwardRef(SvgPortalOutlinedUserIcon);
const Memo = memo(ForwardRef);
export default Memo;
